import googleAnalytics from "./gaPublisher";

export default function create() {
  return [googleAnalytics()];
}
